<template>
    <div class="privatemessage">
        {{this.privatemessage}}
    </div>
</template>

<script>
export default {
    name:'privatemessage',
    data() {
        return {
           privatemessage:'私信信息'
        }
    },
}
</script>

<style lang="less" scoped>
   .privatemessage{
       width: 100%;
       height: 500px;
       background-color: rgb(224, 36, 124);
   }
</style>


// WEBPACK FOOTER //
// src/components/user/usercolumn/privatemessage.vue